import {
  IDictionaryCurrency,
  IDictionaryDealStatus,
  IDictionarySizeDescription,
} from '@/creditflowresearch/domain/vo/IDictionary';
import Tooltip, { TooltipContent } from '@creditflowresearch/uilib/Tooltip';
import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';
import { formatTrancheSizeValues } from './helpers';

import styles from './trancheSizeCell.module.scss';

const SIZE_DESCRIPTION_EXCLUDED_STATUSES = ['PRCD', 'LNCH'];

interface ITrancheSizeCellProps {
  size: number | null,
  sizeDescription: IDictionarySizeDescription | null,
  status: IDictionaryDealStatus | null,
  currency?: IDictionaryCurrency | null,
  benchmarkSize?: boolean,
  decimals?: number,
  getCustomTooltipValue?: (suffix: string) => TooltipContent,
}

const TrancheSizeCell = ({
  size,
  sizeDescription,
  currency,
  status,
  benchmarkSize,
  decimals = 0,
  getCustomTooltipValue,
}: ITrancheSizeCellProps) => {
  const isShowSizeDescription = !!sizeDescription
                                && !SIZE_DESCRIPTION_EXCLUDED_STATUSES.includes(status?.abbreviation);

  const formattedValues = formatTrancheSizeValues({
    size,
    sizeDescription,
    currency,
    benchmarkSize,
    isShowSizeDescription,
    decimals,
  });

  if (!formattedValues) return <>{ EMPTY_CELL_STATE }</>;

  const { displayValue, tooltipValue, tooltipSuffix } = formattedValues;
  const customTooltipValue = getCustomTooltipValue?.(tooltipSuffix);

  return (
    <Tooltip
      disabled={ !tooltipValue && !customTooltipValue }
      content={ customTooltipValue || tooltipValue }
      containerClassName={ styles.container }
    >
      <span>{ displayValue }</span>
    </Tooltip>
  );
};

export default TrancheSizeCell;
